import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../security/authContext";
import { FormLoader, useFormLoader } from "../common_modules/loader";
import API from "../../services/axiosInstance";

const TranscodingInfo = () => {
    // state
    const [data, setData] = useState();

    // hooks
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const { hasPermission } = useAuth();
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook

    // functions
    const transcodeVideoByContentId = async (contentId) => {
        startLoading();
        let res = null;
        try {
            res = await API.get(`meta/content/transcode/by/${contentId}`);
            if (res.status === 200) {
                // alert("Transcoding successfully..");
                // contentList("", paginationData.number);
                setData(res?.data?.data);
            }
        } catch (e) { } finally {
            stopLoading();
        }

        // rediract on transcoding info page 
        // transcodingInfo(res?.data?.data);
    }

    useEffect(() => {
        const contentId = searchParams.get("contentId");
        transcodeVideoByContentId(contentId);
    }, []);

    return (
        <FormLoader isLoading={isLoading} text={"Transcoding Video..."}>
            <div>
                <div className="breadCrumb gradient-bg">
                    <Link to={'/dashboard'}><span>Home</span></Link>
                    <span>Meta Admin</span>
                    <Link to={'/content-management'}><span>Content Management</span></Link>
                    <span>Transcoding Information</span>
                </div>
                <h4 className="my-4 fw-bold">🧾 Transcoding Information</h4>
                <div className="active-table-wrapper">
                    <div class="video-info-container">
                        {
                            data && data?.chunksName?.length > 0 ?
                                <div class="success-message">
                                    Now you can generate Instream JS for this content video.
                                </div>
                                : ""
                        }


                        <table class="video-info-table">
                            <tr>
                                <td>Name</td>
                                <td>{data?.content?.name}</td>
                            </tr>
                            <tr>
                                <td>Video Guid</td>
                                <td>{data?.content?.guid}</td>
                            </tr>
                            <tr>
                                <td>Video Chunks Listing {data?.chunksName.length}</td>
                                <td>
                                    {
                                        data?.chunksName.map((item, i) => {
                                            return <span>{item.split("/")[4]}<br /></span>
                                        })
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td>Upload Status</td>
                                <td>{data?.chunksName.length > 0 && "Complete"}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </FormLoader>
    );
};

export default TranscodingInfo;
